import React from 'react';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
import { ScaleIcon, HeartPulseIcon, WavesIcon, UsersIcon, FlameIcon, HandHeartIcon, BrainIcon, EarIcon, CompassIcon, InfinityIcon } from 'lucide-react';
const keys = [{
  n: '01',
  icon: ScaleIcon,
  title: 'El Equilibrio Interior',
  desc: 'Armoniza tu ser auténtico y aprende a vivir con mayor coherencia entre lo que piensas, sientes y haces.'
}, {
  n: '02',
  icon: HeartPulseIcon,
  title: 'Mi Cuerpo, Mi Templo',
  desc: 'Cultiva vitalidad, descanso, movimiento y cuidado consciente para sostener una vida más plena.'
}, {
  n: '03',
  icon: WavesIcon,
  title: 'Un Universo de Sentimientos',
  desc: 'Comprende tus emociones como mensajeros internos, no como enemigos que debes reprimir.'
}, {
  n: '04',
  icon: UsersIcon,
  title: 'El Arte de Conectar',
  desc: 'Mejora tu forma de comunicarte, vincularte y construir relaciones más auténticas.'
}, {
  n: '05',
  icon: FlameIcon,
  title: 'La Fuerza que Impulsa',
  desc: 'Desarrolla disciplina y resiliencia para avanzar incluso cuando la motivación desaparece.'
}, {
  n: '06',
  icon: HandHeartIcon,
  title: 'Progreso Colectivo',
  desc: 'Explora la empatía, la colaboración y la generación de valor como parte de una vida significativa.'
}, {
  n: '07',
  icon: BrainIcon,
  title: 'Claridad que Ilumina',
  desc: 'Fortalece tu pensamiento estratégico para tomar mejores decisiones y ordenar tu camino.'
}, {
  n: '08',
  icon: EarIcon,
  title: 'La Voz del Corazón',
  desc: 'Aprende a escuchar tu intuición como una guía interna que complementa la razón.'
}, {
  n: '09',
  icon: CompassIcon,
  title: 'La Vocación que Enciende tu Alma',
  desc: 'Conecta con aquello que despierta tu pasión y puede convertirse en propósito.'
}, {
  n: '10',
  icon: InfinityIcon,
  title: 'La Danza de la Armonía',
  desc: 'Integra todas las claves para construir una vida más estable, consciente y plena.'
}];
export const Keys: React.FC = () => <section id="claves" className="relative bg-navy-deep py-28 lg:py-48 overflow-hidden" data-id="element-265">
    <div className="absolute inset-0" style={{
    background: 'radial-gradient(ellipse at top, rgba(212,175,122,0.1), transparent 60%)'
  }} data-id="element-266" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[60%] opacity-40 blur-3xl pointer-events-none" style={{
    background: 'radial-gradient(ellipse, rgba(212,175,122,0.18), transparent 70%)'
  }} data-id="element-267" />

    <div className="relative max-w-7xl mx-auto px-6 lg:px-8" data-id="element-268">
      <div className="text-center mb-20 max-w-3xl mx-auto" data-id="element-269">
        <Reveal data-id="element-270">
          <SectionEyebrow data-id="element-271">Las dimensiones</SectionEyebrow>
        </Reveal>
        <Reveal delay={0.1} data-id="element-272">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.1] text-ivory mb-6 text-balance" style={{
          fontWeight: 300
        }} data-id="element-273">
            Las{' '}
            <span className="italic gold-text" style={{
            fontWeight: 400
          }} data-id="element-274">
              10 claves
            </span>{' '}
            de la estabilidad dimensional
          </h2>
        </Reveal>
        <Reveal delay={0.15} data-id="element-275">
          <p className="text-ivory/65 text-lg leading-[1.8] font-light" data-id="element-276">
            Un mapa profundo para construir equilibrio, claridad y plenitud
            desde adentro hacia afuera.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-277">
        {keys.map((k, i) => <Reveal key={k.n} delay={i * 0.05} data-id="element-278">
            <div className="group relative h-full glass-card rounded-2xl p-8 lg:p-10 transition-all duration-500 hover:border-gold/40 cursor-default overflow-hidden" data-id="element-279">
              {/* Glow */}
              <div className="absolute -inset-px rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
            background: 'radial-gradient(circle at 50% 0%, rgba(212,175,122,0.2), transparent 60%)'
          }} data-id="element-280" />

              <div className="relative flex items-start justify-between mb-7" data-id="element-281">
                <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center bg-navy-mid/60 group-hover:border-gold/60 transition-colors" data-id="element-282">
                  <k.icon className="w-5 h-5 text-gold" strokeWidth={1.4} data-id="element-283" />
                </div>
                <span className="font-serif italic text-3xl gold-text" data-id="element-284">
                  {k.n}
                </span>
              </div>

              <h3 className="relative font-serif text-xl lg:text-[22px] text-ivory mb-3 leading-snug" style={{
            fontWeight: 500
          }} data-id="element-285">
                {k.title}
              </h3>
              <p className="relative text-ivory/60 text-[14px] leading-[1.75] font-light" data-id="element-286">
                {k.desc}
              </p>
            </div>
          </Reveal>)}
      </div>
    </div>
  </section>;